import React from "react";
import { Toolbar, SaveButton } from "react-admin";

export const UndeletableToolbar = (props: any) => {
  const { alwaysEnableSaveButton, transform } = props;

  return (
    <Toolbar {...props}>
      {alwaysEnableSaveButton && <SaveButton transform={transform} type="button" alwaysEnable />}
      {!alwaysEnableSaveButton && <SaveButton transform={transform} type="button" />}
    </Toolbar>
  );
};
